import { PublicClientApplication } from "@azure/msal-browser";

const MICROSOFT_CLIENT_ID = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
const MICROSOFT_TENANT_ID =
  process.env.REACT_APP_MICROSOFT_TENANT_ID || "common";
const MICROSOFT_SCOPES = ["openid", "profile", "email", "User.Read"];

let msalInstancePromise;

const getRedirectUri = () => {
  if (process.env.REACT_APP_MICROSOFT_REDIRECT_URI) {
    return process.env.REACT_APP_MICROSOFT_REDIRECT_URI;
  }

  if (typeof window !== "undefined") {
    return window.location.origin;
  }

  return undefined;
};

const getMsalInstance = async () => {
  if (!MICROSOFT_CLIENT_ID) {
    throw new Error(
      "Missing REACT_APP_MICROSOFT_CLIENT_ID. Configure Microsoft app credentials before using Outlook sign-in.",
    );
  }

  if (!msalInstancePromise) {
    const instance = new PublicClientApplication({
      auth: {
        clientId: MICROSOFT_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${MICROSOFT_TENANT_ID}`,
        redirectUri: getRedirectUri(),
      },
      cache: {
        cacheLocation: "localStorage",
      },
    });

    msalInstancePromise = instance.initialize().then(() => instance);
  }

  return msalInstancePromise;
};

export const getMicrosoftAccessToken = async () => {
  const instance = await getMsalInstance();
  const loginResponse = await instance.loginPopup({
    scopes: MICROSOFT_SCOPES,
    prompt: "select_account",
  });

  if (loginResponse.accessToken) {
    return loginResponse.accessToken;
  }

  const tokenResponse = await instance
    .acquireTokenSilent({
      account: loginResponse.account,
      scopes: MICROSOFT_SCOPES,
    })
    .catch(() =>
      instance.acquireTokenPopup({
        account: loginResponse.account,
        scopes: MICROSOFT_SCOPES,
      }),
    );

  if (!tokenResponse?.accessToken) {
    throw new Error("Unable to retrieve Microsoft access token.");
  }

  return tokenResponse.accessToken;
};
